<template>
  <div>
    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title>
          <div class="md-subheader-no-spacing">
            Disconnect {{ supplierName || "supplier" }}
          </div>
        </v-card-title>

        <v-card-text>
          <div class="md-body-no-spacing">
            Are you sure you want to disconnect? ThreadFlow will stop using
            your {{ supplierName || "supplier" }} account for
            {{ placesOrders ? "pricing and orders" : "pricing" }}.
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn variant="flat" @click="disconnect"> Disconnect </v-btn>
          <v-btn color="primary" class="text-white" @click="close">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
import rules from "@/mixins/rules";
import { mapGetters } from "vuex";
import helpers from "@/mixins/helpers";
import { SUPPLIERS_ORDERED_ON_DISTRIBUTOR_ACCOUNT } from "./supplierAccounts";

export default {
  data() {
    return {
      show: false,
      integrationID: null,
      supplierName: null,
      supplierKey: null,
    };
  },

  watch: {},

  computed: {
    ...mapGetters(["getDistributorId"]),

    placesOrders() {
      return SUPPLIERS_ORDERED_ON_DISTRIBUTOR_ACCOUNT.includes(this.supplierKey);
    },
  },

  mixins: [rules, helpers],

  async mounted() {},

  methods: {
    async disconnect() {
      try {
        let result = await this.$axios.get(
          `/supplier_integrations/disconnectIntegration/${this.integrationID}/${this.getDistributorId}`
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        this.$emit("disconnected");
        this.close();
      }
    },
    open(id, supplier = {}) {
      this.integrationID = id;
      this.supplierName = supplier.name || null;
      this.supplierKey = supplier.supplierKey || null;
      this.show = true;
    },
    close() {
      this.integrationID = null;
      this.supplierName = null;
      this.supplierKey = null;
      this.show = false;
    },
  },
};
</script>

<style scoped>
</style>
